import { useEffect, useState, useMemo } from "react";
import { useRouteMatch } from "react-router-dom";
import DropdownAutoComplete from "../../components/DropdownAutoComplete";
import { makeStyles } from "@material-ui/styles";
import Execution from "./Execution";
import _ from "lodash";
import DefaultLoader from "../../components/DefaultLoader";
import { useWorkflowSearchByRequestId } from "../../data/workflow";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#fafafa", // TODO: Use theme var
    display: "flex",
    paddingLeft: "0",
  },
  body: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
  },
  flexBody: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  centre: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  },
  dropdownContainer: {
    padding: "16px",
    backgroundColor: "#fff",
    borderBottom: "1px solid #e0e0e0",
    minHeight: "64px",
    display: "flex",
    alignItems: "center"
  },
  executionContainer: {
    flex: 1,
    overflow: "hidden"
  }
}));

const OnlyExecutionPage = () => {
  const match = useRouteMatch();

  const classes = useStyles();
  const [workflowId, setWorkflowId] = useState(null);

  const [queryFT, setQueryFT] = useState({
    query: "", freeText: "*"
  });

  const {
    data: resultObj,
    isFetching,
  } = useWorkflowSearchByRequestId({
    query: queryFT.query,
    freeText: queryFT.freeText,
    enabled: !!match.params.id
  });

  // Memoized function to map workflow names and IDs from result object
  const workflowsData = useMemo(() => {
    if (!resultObj?.results || !Array.isArray(resultObj.results)) {
      return [];
    }

    return resultObj.results.map(workflow => ({
      key: workflow.workflowName,
      value: workflow.workflowId, // Fixed: was workflowID, should be workflowId
    }));
  }, [resultObj]);
  // const workflowsData = [{ key: "Demo", value: "qweqwewer" }, { key: "Demo2", value: "qweqwewerwww" }]

  // Dropdown selection function to handle workflow change
  const handleWorkflowSelection = (selectedWorkflow) => {
    if (!selectedWorkflow) {
      setWorkflowId(null);
      return;
    }

    // Handle both object format {key, value} and direct string value
    const workflowIdToSet = typeof selectedWorkflow === 'object'
      ? selectedWorkflow.value
      : selectedWorkflow;

    setWorkflowId(workflowIdToSet);
  };

  useEffect(() => {
    if (workflowsData.length > 0) {
      setWorkflowId(workflowsData[0].value);
    }
  }, [workflowsData]);

  useEffect(() => {
    if (match.params.id) {
      setQueryFT({
        query: `requestId="${match.params.id}"`,
        freeText: "*"
      });
    }
  }, [match.params.id]);

  const FallbackMessage = useMemo(() => ({ requestId }) => (
    <div className={classes.centre}>
      <p>Work flow Id not found for request Id: {requestId}</p>
    </div>
  ), []);

  return (
    <div className={classes.body}>
      {isFetching ? (
        <DefaultLoader
          displayModal={isFetching}
          message="Workflow is getting loaded"
        />
      ) : workflowsData.length > 0 ? (
        <>
          <div className={classes.dropdownContainer}>
            <div style={{ marginRight: '16px', fontSize: '14px', fontWeight: '500' }}>
              Workflows mapped to request ID {match.params.id}:
            </div>
            <DropdownAutoComplete
              label="Select workflow"
              options={workflowsData}
              value={workflowId}
              style={{ minWidth: '300px' }}
              onChange={(event, newValue) => handleWorkflowSelection(newValue)}
            />
          </div>
          <div className={classes.executionContainer}>
            {!_.isNull(workflowId) ? (
              <Execution workflowID={workflowId} view="TICKET_SUMMARY" />
            ) : (
              <div className={classes.centre}>
                <p>Please select a workflow from the dropdown above</p>
              </div>
            )}
          </div>
        </>
      ) : (
        <FallbackMessage requestId={match.params.id} />
      )}
    </div>
  );
};

export default OnlyExecutionPage;
